var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradingStrategiesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 228,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#dc2626"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 452,
    width: 26,
    height: 360,
    rx: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 524,
    width: 136,
    height: 216,
    rx: 20
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#16a34a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 336,
    width: 26,
    height: 440,
    rx: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 404,
    width: 136,
    height: 216,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 734,
    y: 196,
    width: 26,
    height: 440,
    rx: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679,
    y: 264,
    width: 136,
    height: 216,
    rx: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingStrategiesLogo);
export default __webpack_public_path__ + "static/media/trading-strategies-logo.3ab16bff9b7e707a77d7a50d61bb79cb.svg";
export { ForwardRef as ReactComponent };